import { useEffect, useRef, useState } from 'react';
import EditComponent from './FaPiaoEdit';
import WebUniversal, { WUExtendPropsType } from '../system/WebUniversalNewEx'
import { columnsheadId } from '../universal/columnshead';
import { Button, Dropdown, MenuProps, Popconfirm, Popover, Space, Tooltip } from 'antd';
import fetchApi from '../../utils/api/fetchApi';
import AntdNotification from '../../utils/extend/AntdNotification';
import dayjs from 'dayjs';
import { DownOutlined } from '@ant-design/icons';


const WebComponent = (props: any) => {
    const ref = useRef<any>(undefined);
    const [membershipTypeId, setMembershipTypeId] = useState<any>();
    const [modalVisibleMembershipApplicablesShops, setModalVisibleMembershipApplicablesShops] = useState<any>();

    /** 当前打开的 Popover ID */
    const [activePopoverId, setActivePopoverId] = useState<string | null>(null);
    const [activePopoverId2, setActivePopoverId2] = useState<string | null>(null);
    /** 后端数据defaultService */
    const [defaultService, setDefaultService] = useState<string>('');
    const [InitData, setInitData] = useState<any>();

    useEffect(() => {
        let urlService;
        if (ref.current) {
            urlService = ref.current.defaultService;
            setDefaultService(urlService);
            setInitData(() => ref.current.initData);
        }
    }, []);


    // 修改 manageItems 函数
    const manageItems = (payload: any) => {
        const { id, faPiaoQrCodeStatusId, faPiaoStatusId } = payload;
        const items: MenuProps['items'] = [
            {
                label: (
                    <Popconfirm
                        title="是否作废开票二维码？"
                        onConfirm={() => {
                            fetchApi.PUT(defaultService, {
                                apiId: 'faPiao',
                                apiExtend: 'invalidQrCode',
                                apiData: { faPiaoId: id }
                            }).then(res => {
                                if (res?.success) {
                                    AntdNotification('success', '作废开票二维码成功');
                                    InitData?.();
                                } else {
                                    AntdNotification('error', res?.message);
                                }
                            });
                        }}
                        okText="是"
                        cancelText="否"
                        disabled={faPiaoQrCodeStatusId !== 0}
                    >
                        <div
                            onClick={(e) => {
                                if (faPiaoQrCodeStatusId !== 0) {
                                    e.preventDefault();
                                    AntdNotification('warning', '当前二维码状态不允许作废');
                                }
                            }}
                            style={{
                                cursor: faPiaoQrCodeStatusId === 0 ? 'pointer' : 'not-allowed',
                                color: faPiaoQrCodeStatusId === 0 ? 'inherit' : '#ccc'
                            }}
                        >
                            二维码作废
                        </div>
                    </Popconfirm>
                ),
                key: 'invalidQrCode',
                disabled: faPiaoQrCodeStatusId !== 0
            },
            {
                label: '查询',
                key: 'queryQrCode',
                onClick: () => {
                    const apiExtend = faPiaoStatusId === 0 ? 'queryQrCode' : 'queryInfo';
                    fetchApi.GET(defaultService, {
                        apiId: 'faPiao',
                        apiExtend,
                        apiData: { faPiaoId: id, isQueryFaPiao: true }
                    }).then(res => {
                        if (res?.success) {
                            AntdNotification('success', '查询成功，请查看控制台');
                            InitData?.();
                            console.log(res.data);
                        } else {
                            AntdNotification('error', res?.message);
                        }
                    });
                }
            },
            {
                label: (
                    <Popconfirm
                        title="是否发票冲红？"
                        onConfirm={() => {
                            fetchApi.PUT(defaultService, {
                                apiId: 'faPiao',
                                apiExtend: 'red',
                                apiData: { faPiaoId: id }
                            }).then(res => {
                                if (res?.success) {
                                    AntdNotification('success', '发票冲红成功');
                                } else {
                                    AntdNotification('error', res?.message);
                                }
                                InitData?.();
                            });
                        }}
                        okText="是"
                        cancelText="否"
                        disabled={faPiaoStatusId !== 1}
                    >
                        <div
                            onClick={(e) => {
                                if (faPiaoStatusId !== 1) {
                                    e.preventDefault();
                                    AntdNotification('warning', '当前发票状态不允许冲红');
                                }
                            }}
                            style={{
                                cursor: faPiaoStatusId === 1 ? 'pointer' : 'not-allowed',
                                color: faPiaoStatusId === 1 ? 'inherit' : '#ccc'
                            }}
                        >
                            发票冲红
                        </div>
                    </Popconfirm>
                ),
                key: 'red',
                disabled: faPiaoStatusId !== 1
            }
        ];
        return items;
    };

    //表头
    const columnsHead = [
        {
            title: '供应商',
            dataIndex: 'faPiaoSupplier',
            render: (val: any) => val?.name
        },
        {
            title: '代码',
            dataIndex: 'faPiaoCode',
        },
        {
            title: '号码',
            dataIndex: 'faPiaoNumber',
        },
        {
            title: '类型',
            dataIndex: 'faPiaoType',
            render: (val: any) => val?.name
        },
        {
            title: '购买方',
            dataIndex: 'buyerName',
        },
        {
            title: '销售方',
            dataIndex: 'sellerName',
        },
        {
            title: '开票日期',
            dataIndex: 'issueDate',
            render: (text: any) => dayjs(text).format('YYYY-MM-DD HH:mm:ss')
        },
        {
            title: '发票状态',
            dataIndex: 'faPiaoStatus',
            render: (val: any, record: any) => {
                const tooltipText = (val.id === -1) ?
                    `冲红日期：${dayjs(record?.redTime).format('YYYY-MM-DD HH:mm:ss')}` :
                    undefined;
                return (<Tooltip placement="topLeft"
                    title={tooltipText}>
                    {<p style={{ color: val.id === -1 ? 'red' : 'white' }}>{val?.name}</p>}
                </Tooltip>)
            }
        },
        {
            title: '开票二维码',
            dataIndex: 'faPiaoQrCodeStatus',
            render: (val: any, record: any) => {
                const tooltipText = (val.id === -1) ?
                    `二维码作废日期：${dayjs(record?.invalidQrCodeDate).format('YYYY-MM-DD HH:mm:ss')}` :
                    `开二维码日期：${dayjs(record?.openQrCodeDate).format('YYYY-MM-DD HH:mm:ss')}`;
                return (<Tooltip placement="topLeft"
                    title={tooltipText}>
                    {<p style={{ color: val.id === -1 ? 'red' : 'white' }}>{val?.name}</p>}
                </Tooltip>)
            }
        },
        {
            title: '',
            dataIndex: 'id',
            render: (id: string, record: any) => (
                <Dropdown
                    menu={{
                        items: manageItems(record)
                    }}
                    trigger={['click']}
                >
                    <Button size="middle" type="dashed">
                        操作
                        <DownOutlined />
                    </Button>
                </Dropdown>
            )
        }
    ];

    const columns = columnsheadId
        .concat(columnsHead as []);

    let extendProps: WUExtendPropsType = {
        ...props,
        titleName: '发票',
        apiId: 'faPiao',
        columns,
        showStates: true,
        showAdd: false,
        showUseBak: true,
        EditComponent,
        serviceId: 'business'
    };

    return (
        <>
            <Button onClick={() => {
                fetchApi.POST(defaultService,
                    {
                        apiId: 'faPiao',
                        apiExtend: 'generateQrCode',
                        apiData: {
                            sellerName: "500102201007206608",
                            sellerTaxId: "500102201007206608",
                            sellerPhone: "020-87695598",
                            sellerAddress: "中国广州",
                            sellerBankName: "中国工商银行",
                            sellerBankAccountNumber: "8002555698589",
                            faPiaoTypeId: "82",
                            totalAmount: 10,
                            buyerEmail: "4541589@qq.com",
                            faPiaoDetailsOptions: {
                                itemList: [{
                                    itemName: "餐饮服务",
                                    taxClassificationCode: "3070401000000000000",
                                    quantity: 1,
                                    unitPrice: 10,
                                    itemAmount: 10,
                                    taxRate: 0.06
                                }]
                            },
                            merchantId: "",
                            merchantName: "",
                            isExcludeDefaultMerchant: false,
                            shopId: "",
                            shopName: "",
                            isExcludeDefaultShop: false,
                            platformId: "Wx",
                            keyId: "",
                            merchantOrderTypeId: "",
                            merchantOrderId: "",
                            drawerId: "11",
                            drawerName: "开票人陈生",
                            payeeName: "收款人张明",
                            reviewerName: "复核人李天",
                            remarks: "备注：报销"
                        }
                    }).then(res => {
                        if (res?.success === true) {
                            AntdNotification('success', '开票二维码成功');
                            InitData();
                        } else {
                            AntdNotification('error', res?.message);
                        }
                    });
            }}>新增发票</Button>
            <WebUniversal props={extendProps} ref={ref} />
        </>
    )
}

export default WebComponent;
